import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">发现当下最受欢迎的91视频、97视频、51视频等热门影视话题</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className="group relative bg-background-100 hover:bg-background-200/80 rounded-xl p-4 md:p-5 transition-all duration-200 cursor-pointer border border-background-200/60 hover:border-primary-200/40"
            >
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <span className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {topic.label}
                  </span>
                  {topic.hot && (
                    <span className="px-1.5 py-0.5 rounded bg-primary-100 text-primary-700 text-[10px] font-medium whitespace-nowrap">
                      热门
                    </span>
                  )}
                </div>
                <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-500 transition-colors text-sm"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-2">{topic.desc}</p>
              <div className="flex items-center gap-1">
                <i className="ri-eye-line text-[10px] text-foreground-400"></i>
                <span className="text-[10px] text-foreground-400">{topic.count}次浏览</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}